import httpClient from './httpClient'

const END_POINT = '/api/forma_conocers'

const getAll = async () => await httpClient.get(END_POINT)

export {

    getAll

}